import React, { Component } from 'react';
import shanghai from '../../static/images/shanghai.jpg';
import nanjing from '../../static/images/nanjing.jpg';
import {withRouter } from "react-router-dom";
class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  render(){
    return(
      <div className='footerdiv'>
        <div className='footermain '>
          <div className='footerconts container'>
            <div className='flistite'>
              <div className='footertit'>关于我们</div>
              <div className='footernr' onClick={()=>{
	              window.location.href='/aboutus'
              }}>关于美丞</div>
              <div className='footernr' onClick={()=>{
	              window.location.href='/teachers'
              	}}>师资团队</div>
              <div className='footernr' onClick={()=>{
	              window.location.href='/case'}
              }>成功案例</div>
            </div>
            <div className='flistite'>
              <div className='footertit'>最新动态</div>
              <div className='footernr' onClick={()=>{
	              window.location.href='/activity'}}>留学活动</div>
              <div className='footernr' onClick={()=>{window.location.href='/information'}}>留学资讯</div>
            </div>
            <div className='flistite'>
              <div className='footertit'>联系我们</div>
              <div className='footernr'>
              上海总部：<br/>
                上海市普陀区真南路1199弄8号楼28层<br/>
								服务热线： 021-63306793
              </div>
              <div className='footernr'>
              南京：<br/>
                南京市秦淮区中山东路300号长发中心B座1605室<br/>
	              服务热线：025-83755178
              </div>
            </div>
	          <div className='flistite'>
		          <div className='footertit'>上海美丞留学</div>
		          <div className={'imgs'}>
			          <div className={'imgitem'}>
				          <img src={require('../../static/images/shweixin.jpg')} alt=""/>
				          <span>微信公众号</span>
			          </div>
			          <div className={'imgitem'}>
				          <img src={require('../../static/images/shzixun.jpg')} alt=""/>
				          <span>上海小助手</span>
			          </div>
		          </div>
	          </div>
	          <div className='flistite'>
		          <div className='footertit'>南京美丞留学</div>
		          <div className={'imgs'}>
			          <div className={'imgitem'}>
				          <img src={require('../../static/images/shweixin.jpg')} alt=""/>
				          <span>微信公众号</span>
			          </div>
			          <div className={'imgitem'}>
				          <img src={require('../../static/images/njzhushou.jpg')} alt=""/>
				          <span>南京小助手</span>
			          </div>
		          </div>
	          </div>

          </div>
          <div className='copyright'>Copyright ©2020. All Rights Reserved
            <a href='http://www.beian.miit.gov.cn' target='_blank'>苏ICP备09021671号-5</a>
          </div>
        </div>
        <div className='footerPhone'>
        版权所有:
          <a href='http://www.beian.miit.gov.cn' target='_blank'>苏ICP备09021671号-5</a>
        </div>
      </div>
    )
  }
}

export default withRouter(Footer)
